import { getToken } from 'firebase/messaging';
import { jwtDecode } from 'jwt-decode';
import { messaging } from '../firebaseConfig';
import axiosInstance from './axiosInstance';
import { getCookie } from './cookieFunctions';
import { getDeviceId } from './device';

const VAPID_KEY =
  'BEaxmyf1BV6kmOBw8YeI_-Xw_lQtIBmmHu4y-7ro_2FL2aFUO65KNlIBTZwNkdnfy_ej373560sL2nX4zKdtPg8';

// Requests notification permission, gets the FCM token for this browser, and
// pairs it with the current device on the backend. Safe to call multiple times
// (e.g. on login and on app load) — it no-ops when not logged in or permission
// isn't granted.
export async function registerFcmToken(): Promise<void> {
  try {
    const cookieToken = getCookie('peliswan_crm_token');
    if (!cookieToken) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (!token) return;

    const { _id } = jwtDecode(cookieToken) as unknown as { _id: string };
    const deviceId = await getDeviceId();

    await axiosInstance.post(`/users/${_id}/token`, {
      fcm_token: token,
      deviceId,
    });
  } catch (error) {
    console.log('FCM registration error:', error);
  }
}
